var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "i",
    {
      staticClass: "icon-box",
      class: ["icon-" + _vm.type, _vm.status == "disabled" && "is-disabled"]
    },
    [
      _c("img", {
        ref: "icon",
        staticClass: "icon",
        style: _vm.styleObj,
        attrs: { src: _vm.icon },
        on: {
          mouseenter: _vm.onMouseenter,
          mouseleave: _vm.onMouseleave,
          click: _vm.onClick
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0f68a3b8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f68a3b8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/Icon/Icon.vue
// module id = uZ2b
// module chunks = 9